export default __webpack_public_path__ + "static/laptop_b.1fbd2aedac7b07197b0b44cb0846c319.svg";